import domReady from '@wordpress/dom-ready';
import { createRoot, render } from '@wordpress/element';

const App = ( { attributes } ) => {
    const { 
        listItem,
        enableTooltip,
        tooltipContent
		
	} = attributes;

	return (
		<>
            <ul className='wedocs-adv-list-item'>
                <li>
                    <span dangerouslySetInnerHTML={ {
                        __html: listItem
                    } }></span>
                    { enableTooltip && (
                        <div className='tooltipIcon'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M9 0C4.02961 0 0 4.02961 0 9C0 13.9704 4.02961 18 9 18C13.9704 18 18 13.9704 18 9C18 4.02961 13.9704 0 9 0ZM10.2596 12.6622C10.2596 12.9963 10.1269 13.3167 9.89071 13.5529C9.65448 13.7892 9.33408 13.9219 9 13.9219C8.66592 13.9219 8.34552 13.7892 8.10929 13.5529C7.87306 13.3167 7.74035 12.9963 7.74035 12.6622C7.74035 12.3281 7.87306 12.0078 8.10929 11.7715C8.34552 11.5353 8.66592 11.4026 9 11.4026C9.33408 11.4026 9.65448 11.5353 9.89071 11.7715C10.1269 12.0078 10.2596 12.3281 10.2596 12.6622ZM10.427 5.38945L10.2607 9.58852C10.2477 9.91418 10.1092 10.2222 9.87421 10.448C9.6392 10.6739 9.32593 10.8 9 10.8C8.67407 10.8 8.3608 10.6739 8.12579 10.448C7.89079 10.2222 7.75228 9.91418 7.7393 9.58852L7.57301 5.38945C7.56633 5.21972 7.594 5.05039 7.65435 4.89161C7.7147 4.73283 7.80649 4.58787 7.92421 4.46542C8.04193 4.34296 8.18317 4.24554 8.33945 4.17899C8.49574 4.11244 8.66385 4.07814 8.83371 4.07812H9.16629C9.33615 4.07814 9.50426 4.11244 9.66055 4.17899C9.81683 4.24554 9.95807 4.34296 10.0758 4.46542C10.1935 4.58787 10.2853 4.73283 10.3457 4.89161C10.406 5.05039 10.4337 5.21972 10.427 5.38945Z" fill="#D4DFEC"/>
                            </svg>
                            {
                                tooltipContent && (
                                    <div className='tooltipContent'>
                                        <p>{tooltipContent}</p>
                                    </div>
                                )
                            }
                        </div>
                    ) }
                   
                </li>
            </ul>
        </>
	);
};

domReady( () => {
	const mountElement = document.querySelectorAll(
		'.wp-block-wedocs-gblocks-list-item'
	);
	const mountElementArr = Array.from( mountElement );

	mountElementArr.forEach( ( item ) => {
		if ( createRoot ) {
			createRoot( item ).render(
				<App
					attributes={ JSON.parse(
						item.getAttribute( 'data-block-attributes' )
					) }
				/>
			);
		} else {
			render(
				<App
					attributes={ JSON.parse(
						item.getAttribute( 'data-block-attributes' )
					) }
				/>,
				item
			);
		}
	} );
} );